import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isEmpty,
  noop,
} from 'lodash';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import qs from 'qs';
import { currentUserRoleSelector } from 'redux/auth/selectors';
import ShopCard from './ShopCard';
import immutableToJS from 'helpers/immutableToJS';

import {
  injectIntl,
} from 'components';
import { selectState } from 'redux/selectors';
import {
  setCartLocalStorage, getCartLocalStorage,
} from 'helpers/utils';

class Shop extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    setHotNotification: PropTypes.func,
    isConsumer: PropTypes.bool,
    isPublic: PropTypes.bool,
  };

  static propTypes = {
    currentUserRole: PropTypes.string,
    history: PropTypes.shape({
      location: PropTypes.shape({
        search: PropTypes.string,
      }).isRequired,
      push: PropTypes.func.isRequired,
    }).isRequired,
    account: PropTypes.shape({}),
    currentRoleId: PropTypes.number,
    details: PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
    globals: PropTypes.arrayOf(PropTypes.shape({})),
    sortDirection: PropTypes.string,
    shop: PropTypes.shape({}).isRequired,
    type: PropTypes.string,
  };

  static defaultProps = {
    account: {},
    details: [],
    globals: [],
    currentRoleId: 3,
    sortDirection: '',
    type: '',
    currentUserRole: '',
  };

  state = {
    currentPageIndex: 1,
    dataFiltered: [],
    tableViewMode: 1,
    currentImage: 0,
    lightboxIsOpen: false,
    distributorsPopup: false,
    distributorsMobilePopup: false,
    open: false,
    dialogMessage: '',
    invoice: {
      items: {},
    },
    currentOrderSheetCardId: -1,
    openOrdersheetId: -1,
    cartEmpty: true,
    expanded: false,

    activeNotifications: [],
    notificationsDialogOpen: false,
    sellerForNotifications: null,
  };

  componentWillMount() {
    const { currentUser, isPublic } = this.context;
    const { history } = this.props;

    const { deliveryDate } = qs.parse(history.location.search.substring(1));
    const invoiceLocalStorage = getCartLocalStorage();
    if (!deliveryDate && invoiceLocalStorage.deliveryDate) {
      const publicPathname = history.location.pathname;
      history.push(`${publicPathname}?deliveryDate=${invoiceLocalStorage.deliveryDate}`);
    }
    if (!isPublic) {
      const role = {
        2: 'Buyer',
        3: 'Distributor',
        4: 'Seller',
        5: 'Consumer',
      }[currentUser.account.currentRoleId] || 'Personal';
      if ((role === 'Consumer' || role === 'Personal') && !currentUser.account.profile.firstName && !currentUser.account.profile.lastName) {
        const pathname = '?redirect_url=shop';
        history.push(`/settings${pathname}`);
      } else if (role !== 'Consumer' && role !== 'Personal') {
        history.push('/order');
      }
    } else if (isPublic && currentUser.id) {
      const pathname = '?redirect_url=shop';
      history.push(`/settings${pathname}`);
    }
  }

  setExpanded = (expanded) => {
    const { history } = this.props;
    const { deliveryDate } = qs.parse(history.location.search.substring(1));
    // this.setState({ currentOrderSheetCardId: expanded }, () => {
    //   history.push(expanded === -1 ? '/shop' : `/shop?suid=${expanded}&deliveryDate=${deliveryDate || ''}`);
    // });
  }

  setInvoice = (newInvoice) => {
    this.setState({ invoice: newInvoice, cartEmpty: isEmpty(newInvoice.items) });
    setCartLocalStorage(newInvoice);
  }

  setOpen = (open, orderSheetId = -1) => {
    this.setState({ open, openOrdersheetId: orderSheetId });
  }

  showNotifications = (seller, notifications) => this.setState({
    activeNotifications: notifications,
    notificationsDialogOpen: true,
    sellerForNotifications: seller,
  });

  render() {
    const { currentUser } = this.context;
    const { expanded } = this.state;
    const { currentUserRole, history, shop, type } = this.props;
    const isRest = currentUserRole === 'Consumer';
    const { suid, deliveryDate } = qs.parse(history.location.search.substring(1));
    const expandedId = shop && shop.sellerProfile ? shop.sellerProfile.id : 0;
    const isShopPage = true;
    return (
      <React.Fragment>
        <div className="order-sheets-page">
          <ShopCard
            deliveryDate={deliveryDate}
            helper="order-sheets"
            history={history}
            isRest={isRest}
            location={history.location}
            onCreateContactSuccess={(() => {
              const publicPathname = history.location.pathname;
              history.push(publicPathname);
            })}
            push={history.push}
            invoice={this.state.invoice}
            setInvoice={this.setInvoice}
            setOpen={this.setOpen}
            currentOrderSheetCardId={this.state.currentOrderSheetCardId}
            cartEmpty={this.state.cartEmpty}
            setDeliveryDate={((expanded, date) => {
              const publicPathname = history.location.pathname;
              history.push( `${publicPathname}?${date ? `deliveryDate=${date}` : ''}`);
            })}
            suid={suid}
            contact={shop}
            currentUser={currentUser}
            expanded={expanded === expandedId}
            index={0}
            info={shop.sellerProfile}
            isVendor={false}
            key={shop.id}
            setExpanded={expanded =>
              this.setState({ expanded })}
            title={''}
            showNotifications={type === 'stores' ? this.showNotifications : noop}
            isShopPage={isShopPage}
          />
        </div>
      </React.Fragment>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('options', 'globals')(state, 'globals'),
  ...selectState('options', 'tags')(state, 'tags'),
  currentUserRole: currentUserRoleSelector(state),
});

const mapDispatchToProps = dispatch => ({
});

export default compose(
  setDisplayName('Shop'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  injectIntl,
  immutableToJS,
)(Shop);
